import styled from 'styled-components';

import Text from 'components/_core/Text';

export const CardAssetContainer = styled.div`
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.08));
  position: relative;
`;

export const CardImage = styled.img<{ isActive: boolean; creating?: boolean }>`
  width: 263px;
  height: 167px;
  ${({ isActive }) => (!isActive ? 'opacity: 0.6;' : '')}
  ${({ creating }) =>
    creating
      ? 'filter: grayscale(1);drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.08));'
      : 'filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.08));'}
  border-radius: ${({ theme }) => theme.spacings.abs8}px;
`;

export const CardInformationContainer = styled.div`
  bottom: ${({ theme }) => theme.spacings.abs16}px;
  left: ${({ theme }) => theme.spacings.abs16}px;
  position: absolute;
`;

export const SectionTitle = styled.div`
  margin: 0 ${({ theme }) => theme.spacings.abs8}px
    ${({ theme }) => theme.spacings.abs16}px;
`;

export const OldDesignStatusBadgeContainer = styled.div`
  display: flex;
  z-index: 1;
  margin-top: ${({ theme }) => theme.spacings.abs16}px;
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const StatusBadgeContainer = styled(OldDesignStatusBadgeContainer)`
  margin-left: ${({ theme }) => theme.spacings.abs16}px;
  margin-bottom: 0;
  position: absolute;
`;

export const CardSecurityDetailsLabel = styled(Text).attrs({
  size: 'sm',
})``;

export const IconContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.ctaBlue(4)};
  border-radius: 50%;
  display: flex;
  flex: 0 1;
  justify-content: center;
  margin-right: ${({ theme }) => theme.spacings.abs8}px;
  padding: ${({ theme }) => theme.spacings.abs8}px;
`;

export const CopyContainer = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 8px;
  display: flex;
  padding-left: ${({ theme }) => theme.spacings.abs8}px;
  padding-right: ${({ theme }) => theme.spacings.abs8}px;
  &:not([disabled]) {
    cursor: pointer;
  }
  :hover > ${IconContainer} {
    background-color: ${({ theme }) => theme.colors.ctaBlue(3)};
  }
  :hover > ${CardSecurityDetailsLabel} {
    color: ${({ theme }) => theme.colors.ctaBlue(-1)};
  }
`;

export const RevealContainer = styled(CopyContainer)``;
